'use strict';

angular.module('impactx.util', []);